<ng-template [ngIf]="menu">
  <nav class="container utility-nav text-end position-relative hidden-xs">
    <ng-container [brManageMenuButton]="siteMenu"></ng-container>
    <ul class="list-inline m-0 top-nav" [ngClass]="{ 'has-edit-button': page?.isPreview() }">
      <li class="list-inline-item" *ngFor="let item of menu" [ngClass]="{ dropdown: item.childMenuItems?.length > 0 }" (click)="displaySubMenu(item.parameters?.isClientLogin)">
        <a
          *ngIf="!item.parameters?.isClientLogin && !isCustodyPage && item.links.site.type==='internal'"
          [routerLink]="page.getUrl(item.links.site?.href)"
          [ngClass]="{ 'client-login': item.parameters?.isClientLogin }"
          aria-current="page"
          >{{ item.name }}</a
        >
        <a
          *ngIf="!item.parameters?.isClientLogin && !isCustodyPage && item.links.site.type==='external'"
          [href]="item.links.site?.href"
          aria-current="page"
          >{{ item.name }}</a
        >
        <a *ngIf="item.parameters?.isClientLogin" [ngClass]="{ 'client-login': item.parameters?.isClientLogin }" aria-current="page">{{ item.name }}</a>
          <ul class="dropdown-menu dropdown-menu-right dropdown-menu-color" *ngIf="item.childMenuItems && item.childMenuItems.length > 0" [ngClass]="{ open: showSubmenu }">
            <li *ngFor="let childMenuItem of item.childMenuItems" class="submenu">
              <a [href]="childMenuItem.links.site?.href" aria-current="page" (click)="openPopup(childMenuItem, $event)">{{ childMenuItem.name }}</a>
            </li>
          </ul>
      </li>
    </ul>
  </nav>
</ng-template>
